/**
 * @desc 作废采购调价申请单的sku
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.ProcurementOrderRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/cancellationSku`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
